module.exports = __webpack_public_path__ + "static/media/Spinner.b90bb8e4.gif";